import { EntityInformation } from '@/types/admin';
import Button from '@/components/elements/Button';
import { FormEvent, useState } from 'react';
type EntityDetailsProps = {
  entity: EntityInformation;
  saveEntity: (entityInfo: EntityInformation) => void;
};
function EntityDetails(entityInformation: EntityDetailsProps) {
  const [updatedEntity, setEntityFields] = useState<EntityInformation>(entityInformation.entity);
  const handleChange = (event: FormEvent<HTMLInputElement>) => {
    const name = event.currentTarget.name;
    const value = event.currentTarget.value;
    setEntityFields((values) => ({ ...values, [name]: value }));
    if (updatedEntity) {
      console.log(updatedEntity);
    }
  };
  return (
    <div data-cy='entity-details' className='flex flex-col px-8 pb-4 border-2 rounded-md'>
      <h4>Profile Details</h4>
      <div className='grid grid-cols-3 gap-2 '>
        <div className='content-center'>
          <label
            htmlFor='base-input'
            className='items-center  inline-block align-middle text-sm font-medium text-gray-900 '
          >
            Company Name
          </label>
        </div>
        <div className='col-span-2'>
          <input
            type='text'
            name='name'
            value={updatedEntity.name}
            onChange={handleChange}
            className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5'
          />
        </div>
        <div className='content-center'>
          <label
            htmlFor='base-input'
            className='items-center  inline-block align-middle text-sm font-medium text-gray-900 '
          >
            Description
          </label>
        </div>
        <div className='col-span-2'>
          <input
            type='text'
            name='description'
            value={updatedEntity.description}
            onChange={handleChange}
            className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5'
          />
        </div>
        <div className='content-center'>
          <label
            htmlFor='base-input'
            className='items-center  inline-block align-middle text-sm font-medium text-gray-900 '
          >
            Address Line One
          </label>
        </div>
        <div className='col-span-2'>
          <input
            type='text'
            name='addressLineOne'
            value={updatedEntity.addressLineOne}
            onChange={handleChange}
            className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5'
          />
        </div>
        <div className='content-center'>
          <label
            htmlFor='base-input'
            className='items-center  inline-block align-middle text-sm font-medium text-gray-900 '
          >
            Address Line Two
          </label>
        </div>
        <div className='col-span-2'>
          <input
            type='text'
            name='addressLineTwo'
            value={updatedEntity.addressLineTwo}
            onChange={handleChange}
            className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5'
          />
        </div>
        <div className='content-center'>
          <label
            htmlFor='base-input'
            className='items-center  inline-block align-middle text-sm font-medium text-gray-900 '
          >
            City
          </label>
        </div>
        <div className='col-span-2'>
          <input
            type='text'
            name='city'
            value={updatedEntity.city}
            onChange={handleChange}
            className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5'
          />
        </div>
        <div className='content-center'>
          <label
            htmlFor='base-input'
            className='items-center  inline-block align-middle text-sm font-medium text-gray-900 '
          >
            State
          </label>
        </div>
        <div className='col-span-2'>
          <input
            type='text'
            name='state'
            value={updatedEntity.state}
            onChange={handleChange}
            className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5'
          />
        </div>
        <div className='content-center'>
          <label
            htmlFor='base-input'
            className='items-center  inline-block align-middle text-sm font-medium text-gray-900 '
          >
            Postcode
          </label>
        </div>
        <div className='col-span-2'>
          <input
            type='text'
            name='postalCode'
            value={updatedEntity.postalCode}
            onChange={handleChange}
            className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5'
          />
        </div>

        <div className='content-center'>
          <label
            htmlFor='base-input'
            className='items-center  inline-block align-middle text-sm font-medium text-gray-900 '
          >
            Country
          </label>
        </div>
        <div className='col-span-2'>
          <input
            type='text'
            name='country'
            value={updatedEntity.country}
            onChange={handleChange}
            className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5'
          />
        </div>
      </div>
      <Button buttonText='Update' variant='gradient' onClick={() => entityInformation.saveEntity(updatedEntity)} />
    </div>
  );
}

export default EntityDetails;
